import React from 'react';
import { HelpPopover } from '@gravity-ui/components';
import { ChevronDown } from '@gravity-ui/icons';
import { Button, Icon, Popover, Text } from '@gravity-ui/uikit';
import { COMMON_POPOVER_PLACEMENT } from '../../constants/common';
import { block } from '../../utils';
import './SimpleVerticalAccordeon.css';
const b = block('simple-vertical-accordeon');
const TITLE_TEXT_MAX_WIDTH = 485; /** 533px (COMMON_TITLE_MAX_WIDTH) - 48px of padding */
export class SimpleVerticalAccordeon extends React.Component {
    constructor(props) {
        super(props);
        this.componentRef = React.createRef();
        this.titleRef = React.createRef();
        this.checkVisibility = () => {
            if (this.props.viewLayout) {
                if (this.componentRef.current &&
                    this.componentRef.current.children.length &&
                    this.state.hidden) {
                    this.setState({ hidden: false });
                }
                else if (this.componentRef.current &&
                    !this.componentRef.current.children.length &&
                    !this.state.hidden) {
                    this.setState({ hidden: true });
                }
            }
        };
        this.handleClick = () => {
            const { onOpenChange } = this.props;
            const open = !this.state.open;
            this.setState({ open });
            if (onOpenChange) {
                onOpenChange(open);
            }
        };
        this.state = { open: props.open, hidden: true, isFirstRender: true };
    }
    componentDidUpdate(prevProps) {
        const { open } = this.props;
        if (prevProps.open !== open) {
            this.setState({ open });
        }
        this.checkVisibility();
    }
    componentDidMount() {
        this.setState({ isFirstRender: false });
        this.checkVisibility();
    }
    render() {
        var _a;
        const { children, headerActionsTemplate, className, contentClassName, buttonClassName, hideInsteadOfDestroy, withBranchView, viewLayout, name, } = this.props;
        const { open, hidden, isFirstRender } = this.state;
        const content = hideInsteadOfDestroy ? (React.createElement("div", { ref: this.componentRef, className: b('body', { hidden: !open }) }, children)) : (open && (React.createElement("div", { ref: this.componentRef, className: b('body', contentClassName) }, children)));
        if (viewLayout && !isFirstRender && hidden) {
            return null;
        }
        const title = this.getTitle();
        const titlePopoverDisabled = (((_a = this.titleRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0) <= TITLE_TEXT_MAX_WIDTH;
        const currentTitleVariant = this.getCurrentTitleVariant();
        return (Boolean(React.Children.count(children)) && (React.createElement("div", { className: b({ branch: withBranchView, view: viewLayout }, className) },
            React.createElement("div", { className: b('header') },
                React.createElement(Popover, { content: title, disabled: titlePopoverDisabled, placement: COMMON_POPOVER_PLACEMENT },
                    React.createElement(Button, { view: "flat", className: b('header-inner', buttonClassName), onClick: this.handleClick, qa: `${name}-accordeon-toggler`, width: "auto" },
                        React.createElement(Text, { variant: currentTitleVariant }, title),
                        React.createElement(Icon, { data: ChevronDown, className: b('chevron', { open }), size: 16 }))),
                this.getTooltip(),
                headerActionsTemplate ? headerActionsTemplate : null),
            content)));
    }
    getTitle() {
        const { openTitle, title } = this.props;
        if (!openTitle) {
            return title;
        }
        return this.state.open ? openTitle : title;
    }
    getCurrentTitleVariant() {
        const { titleSize } = this.props;
        if (titleSize === 'm') {
            return 'body-2';
        }
        if (titleSize === 'l') {
            return 'body-3';
        }
        return 'body-1';
    }
    getTooltip() {
        const { note } = this.props;
        return note ? (React.createElement(Text, { className: b('tooltip') },
            React.createElement(HelpPopover, { htmlContent: note, placement: ['bottom', 'top'] }))) : null;
    }
}
SimpleVerticalAccordeon.defaultProps = {
    titleSize: 's',
    open: false,
    withBranchView: false,
};
